/** API route map: URLS.Controller.EmployeeExtension */
// EN-29663 — employee_extension settings for the current employee (no_dd_approval_required).
export const EmployeeExtension = {
      Name: 'EmployeeExtension/',
      GetNoDdApprovalRequired: 'dd-approval-required',
};
